import {
  ADMIN_MENU_SETTINGS_URLS,
  AGENCY_URLS,
  ASSET_URLS,
  BANK_URLS,
  DESIG_URLS,
  DOC_CHECK_LIST_URLS,
  LOCATION_URLS,
  PRACTICAL_URLS,
  QUESTIONS_URLS,
  ROLE_URLS,
  SETTINGS_URL,
  USER_URLS,
} from "../../api/AdminUrls";
import {
  EMPLOYEE_ASSETS_URLS,
  EMPLOYEE_URLS,
  PROJECTS_URLS,
} from "../../api/EmployeeUrls";
import {
  LEAVE_TYPES_URLS,
  SALARY_COMPONENT_URLS,
} from "../../api/SettingsUrls";
import { get, post } from "../smartApiService";

/**
 *
 * @param url s
 * @param call_back
 * @returns
 */
const admin_generic_select = (url: string, call_back: any) => {
  const handleError = (errorMessage: any) => {};
  const subscription = get(url).subscribe((response) => {
    call_back(response.data);
  });
  return () => {
    subscription.unsubscribe();
  };
};
const admin_generic_select_post = (url: string, _data: any, call_back: any) => {
  const handleError = (errorMessage: any) => {};
  const subscription = post(url, _data, { handleError: handleError }).subscribe(
    (response) => {
      call_back(response.data);
    }
  );
  return () => {
    subscription.unsubscribe();
  };
};
/**
 *
 * @param call_back
 * @returns
 */

const user_get_select = (call_back: any) => {
  let url = USER_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
const employee_get_select = (call_back: any) => {
  let url = EMPLOYEE_URLS.GET_ALL_SELECT;
  admin_generic_select_post(url, {}, call_back);
};
const role_get_select = (call_back: any) => {
  let url = ROLE_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
const category_get_all_select = (call_back: any) => {
  let url = QUESTIONS_URLS.GET_ALL_SELECT_CATEGORY;
  admin_generic_select(url,  call_back);
};

const desig_get_select = (call_back: any) => {
  let url = DESIG_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
const agency_get_all_select = (call_back: any) => {
  let url = AGENCY_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};

const salary_component_get_select = (call_back: any) => {
  let url = SALARY_COMPONENT_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};

const location_get_all_select = (call_back: any) => {
  let url = LOCATION_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
const leave_types_get_all_select = (call_back: any) => {
  let url = LEAVE_TYPES_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
const check_list_get_all_select = (call_back: any) => {
  let url = DOC_CHECK_LIST_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};

const admin_assets_get_all_type = (call_back: any) => {
  let url = ASSET_URLS.GET_ALL_SELECT_TYPE;
  admin_generic_select(url, call_back);
};

const admin_bank_get_all_names = (payload: any, call_back: any) => {
  let url = BANK_URLS.GET_ALL_SELECT;
  admin_generic_select_post(url, payload, call_back);
};

const admin_assets_get_all_select = (call_back: any, payload: any) => {
  let url = ASSET_URLS.GET_ALL_SELECT;
  admin_generic_select_post(url, payload, call_back);
};

const admin_employee_project_get_all_select = (
  call_back: any,
  payload: any = {}
) => {
  let url = PROJECTS_URLS.GET_ALL_SELECT_MAN;
  admin_generic_select_post(url, payload, call_back);
};
const admin_employee_get_all_select = (call_back: any, payload: any = {}) => {
  let url = PROJECTS_URLS.GET_ALL_SELECT_EMP;
  admin_generic_select_post(url, payload, call_back);
};
const employee_assets_project_get_all_select = (
  call_back: any,
  payload: any = {}
) => {
  let url = EMPLOYEE_ASSETS_URLS.GET_ALL_SELECT;
  admin_generic_select_post(url, payload, call_back);
};
const menu_role_get_select = (call_back: any) => {
  let url = ADMIN_MENU_SETTINGS_URLS.ROLE_GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
const menu_role_get_select_label = (call_back: any) => {
  let url = ADMIN_MENU_SETTINGS_URLS.ROLE_GET_ALL_SELECT_LABEL;
  admin_generic_select(url, call_back);
};
const menu_Parent_get_select = (call_back: any, payload: any = {}) => {
  let url = ADMIN_MENU_SETTINGS_URLS.GET_ALL_SELECT;
  admin_generic_select_post(url, payload, call_back);
};

const const_get_all_select = (call_back: any, payload: any = {}) => {
  let url = SETTINGS_URL.GET_ALL_SELECT_TYPES;
  admin_generic_select_post(url, payload, call_back);
};
const admin_category_select = (call_back: any) => {
  let url = PRACTICAL_URLS.GET_ALL_SELECT;
  admin_generic_select(url, call_back);
};
// const admin_category_select = (call_back: any, payload: any = {}) => {
//   let url = PRACTICAL_URLS.GET_ALL_SELECT;
//   admin_generic_select_post(url, payload, call_back);
// };
export {
  admin_assets_get_all_select,
  admin_assets_get_all_type,
  admin_bank_get_all_names,
  admin_employee_get_all_select,
  admin_employee_project_get_all_select,
  agency_get_all_select,
  check_list_get_all_select,
  const_get_all_select,
  desig_get_select,
  employee_assets_project_get_all_select,
  employee_get_select,
  leave_types_get_all_select,
  location_get_all_select,
  menu_Parent_get_select,
  menu_role_get_select,
  menu_role_get_select_label,
  role_get_select,
  salary_component_get_select,
  user_get_select, admin_category_select,
  category_get_all_select,
};
